import { NationalCodePattern } from "./RegexPaterns";

export const checkIsMobile = (user) => {
    if(!user.length){
        return false
    }
    let result = user.match(
        /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
    );
    if(!result){
        return false
    }
    return result[0];
}

export const checkIsEmail = (user) => {
    if(!user.length){
        return false
    }
    let result = user.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if(!result){
        return false
    }
    return result[0];
}


export const checkBaseUserData = (user) => {
    let patternID = /^[0-9]{10}$/;
    let newVal = patternID.test(user.U_IDNUMBER);
    if(newVal === false) {
        return false;
    }

    if(!user.U_FNAME || !user.U_LNAME || !user.U_IDNUMBER){
        return false;
    } else {
        return true;
    }
}